module.exports = __webpack_public_path__ + "static/media/launch_tabs.bc388401.png";